import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { ClientService } from '@app/core/client/services/client.service';
import { CompanyService } from '@app/core/client-user';

@Component({
  selector: 'filter-staff',
  templateUrl: './filter-staff.component.html',
  styleUrls: ['./filter-staff.component.scss'],
})
export class FilterStaffComponent implements OnInit {
  constructor(
    public clientSvc :ClientService,
    private cd :ChangeDetectorRef,
    private companyService :CompanyService,
  ) {}

  @Input() value :number[] | number;
  @Input() label :string = 'Client';
  @Output() changeStaff :EventEmitter<number[] | number> = new EventEmitter<
    number[] | number
  >();
  @Input() options :{ multi :boolean } = { multi: false };

  staffSubscription :Subscription;
  staffs :any[] = [];

  ngOnInit() :void {
    this.formatValueToArray();
    this.loadStaffs();
  }

  onChange() {
    this.changeStaff.emit(this.value);
  }

  trackClientByFn(item :any) {
    return item.id;
  }

  private formatValueToArray() :void {
    if (this.value && this.options.multi && !Array.isArray(this.value)) {
      const value = String(this.value)?.split(',');
      if (value.length > 0) {
        this.value = value.map(function (id) {
          return parseInt(id);
        });
      } else {
        this.value = [];
      }
    }
  }

  private loadStaffs() {
    this.companyService.getRecords();
    this.staffSubscription = this.companyService.assignee$.subscribe((resp) => {
      this.staffs = resp;
      this.cd.detectChanges();
    });
  }

  staffSearchFn(term :string, item :object) :boolean {
    const termInput :string = term.toLocaleLowerCase();

    return (
      item['lastname'].toLocaleLowerCase().indexOf(termInput) > -1 ||
      item['firstname'].toLocaleLowerCase().indexOf(termInput) > -1
    );
  }
}
